// Composable for TAB-Key to switch inputs and not firing validate function

import { ref, onMounted, onBeforeUnmount } from 'vue'

const useTabKeyValidation = (inputValidate) => {
  const tabKeyPressed = ref(false)

  const handleTabKey = (e) => {
    if (e.key === 'Tab') {
      tabKeyPressed.value = true
    }
  }

  const validateOnBlur = () => {
    if (tabKeyPressed.value) {
      tabKeyPressed.value = false
      return
    }

    inputValidate()
  }

  onMounted(() => {
    document.addEventListener('keydown', handleTabKey)
  })

  onBeforeUnmount(() => {
    document.removeEventListener('keydown', handleTabKey)
  })

  return {
    validateOnBlur
  }
}

export default useTabKeyValidation
